<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> موقعیت خودروها در زمان </span>

    </div>

</div>

<main style="direction: rtl;">

    <div class="row gx-0 gy-0">

        <div class="col-8 p-1">

            <div class="position-relative w-100 h-100 ">

                <div id="timeline_map" class="w-100 h-100"></div>

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

                <div class="position-absolute" id="map_tooltips" data-bs-html="true"></div>

            </div>

        </div>

        <div class="col-4 p-1">

            <div class="w-100 h-100 ">

                <div [formGroup]="mdl_Search" class="row gx-0 gy-0 p-1">

                    <!-- تاریخ -->

                    <div class="col-6 p-1">

                        <div class="position-relative w-100 h-100">

                            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                                [dateGregorianFormat]="'YYYY/MM/DD'" [dateInitValue]="false"
                                [dateFormat]="'jYYYY/jMM/jDD'">

                                <input type="text" formControlName="strDate" placeholder="تاریخ را مشخض کنید"
                                    class="form-control h-100" />

                            </ng-persian-datepicker>

                        </div>

                    </div>

                    <!-- ساعت -->

                    <div class="col-6 p-1">

                        <div class="position-relative w-100 h-100">

                            <div class="input-group clockpicker">

                                <input type="text" formControlName="strTime" placeholder="ساعت را مشخص کنید" class="form-control h-100 rounded" id="Stime">

                                <span class="input-group-addon">

                                    <span class="glyphicon glyphicon-time"></span>

                                </span>

                            </div>

                        </div>

                    </div>

                    <!-- جستجو -->

                    <div class="col-12 p-1">

                        <button class="w-100 btn btn-primary" (click)="search_Timeline()"> جستجو </button>

                    </div>

                    <!-- جدول اطلاعات -->

                    <div class="col-12 p-1">

                        <div class="w-100 h-100 mt-3">

                            <!-- فیلتر -->

                            <div class="w-100">

                                <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." (input)="filter($event.target)">

                            </div>

                            <!-- خودرو ها -->

                            <div class="w-100">

                                <div class="section border border-2 mt-2">

                                    <table class="table table-striped bg-white mt-1 dirI" id="excel-list">

                                        <thead>

                                            <tr class="text-center">

                                                <th scope="col"> # </th>

                                                <th scope="col"> راننده </th>

                                                <th scope="col"> موبایل </th>

                                                <th scope="col"> زمان </th>

                                            </tr>

                                        </thead>

                                        <tbody>

                                            <tr class="f14 text-center pointer" *ngFor="let item of allCar;let i=index" (click)="focusOnCar(item)">

                                                <td class="text-dark">{{ i + 1 | faNum }}</td>

                                                <td class="text-dark"> {{ item.strFullName | faNum }} </td>

                                                <td class="text-dark"> {{ item.strMobile | faNum }} </td>

                                                <td class="text-dark"> {{ item.strTime | faNum }} </td>

                                            </tr>

                                        </tbody>

                                    </table>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</main>